import get from "lodash.get";
import { REHYDRATE } from "redux-persist";
import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import FlowActionTypes from "./types";

const initialState = {
  general: {
    initialized: false,
  },
  details: {
    initialized: false,
  },
  distribution: {
    initialized: false,
  },
  travelTime: {
    initialized: false,
  },
  attendance: {
    initialized: false,
  },
  chronology: {
    initialized: false,
  },
  categoryCount: {
    initialized: false,
  },
  map: {
    initialized: false,
  },
  trafficChart: {
    initialized: false,
  },
  filters: {
    initialized: false,
    from: 0,
    to: 0,
    attendance: {
      x_axis: "HOUR",
      range: { fromHour: 9 * 3600, toHour: 18 * 3600 },
    },
    travelTime: {
      x_axis: "HOUR",
      range: { fromHour: 9 * 3600, toHour: 18 * 3600 },
    },
    chronology: {
      x_axis: "24H",
    },
    categoryCount: {
      x_axis: "HOUR",
    },
    trafficChart: {
      x_axis: "5MIN",
      range: { fromHour: 9 * 3600, toHour: 18 * 3600 },
    },
    inOutDistributionByPercentage: true,
  },
  autoRefresh: false,
  initialized: false,
};

const FlowReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
        map: {
          ...get(initialState, "map"),
          ...(get(action, "payload.Flow.map.selectedLayers") && {
            selectedLayers: [...get(action, "payload.Flow.map.selectedLayers")],
          }),
        },
      };
    case ContractActionTypes.SWITCH_CONTRACT:
    case AuthenticationActionTypes.LOG_OUT:
      return initialState;
    case FlowActionTypes.SET_LOADING:
      return {
        ...state,
        [action.statName]: {
          ...state[action.statName],
          initialized: false,
        },
      };
    case FlowActionTypes.SET_AUTO_REFRESH:
      return {
        ...state,
        autoRefresh: action.autoRefresh,
      };
    case FlowActionTypes.SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.key]: action.value,
        },
      };
    case FlowActionTypes.SET_ATTENDANCE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          attendance: {
            ...state.filters.attendance,
            [action.key]: action.value,
          },
        },
      };
    case FlowActionTypes.SET_TRAVEL_TIME_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          travelTime: {
            ...state.filters.travelTime,
            [action.key]: action.value,
          },
        },
      };
    case FlowActionTypes.SET_CHRONOLOGY_TIME_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          chronology: {
            ...state.filters.chronology,
            [action.key]: action.value,
          },
        },
      };
    case FlowActionTypes.SET_SELECTED_LAYERS:
      return {
        ...state,
        map: {
          ...state.map,
          selectedLayers: action.layers,
        },
      };
    case FlowActionTypes.SET_GENERAL_STATS:
      return {
        ...state,
        general: {
          ...action.stats,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_DETAILS_STATS:
      return {
        ...state,
        details: {
          ...action.stats,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_DISTRIBUTION_STATS:
      return {
        ...state,
        distribution: {
          ...action.stats,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_ATTENDANCE_GRAPH:
      return {
        ...state,
        attendance: {
          ...(state.attendance || {}),
          ...action.data,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_ATTENDANCE_TIME_LIMIT:
      return {
        ...state,
        attendance: {
          ...(state.attendance || {}),
          [action.key]: action.value,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_TRAVEL_TIME_GRAPH:
      return {
        ...state,
        travelTime: {
          ...(state.travelTime || {}),
          ...action.data,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_CHRONOLOGY_GRAPH:
      return {
        ...state,
        chronology: {
          ...(state.chronology || {}),
          ...action.data,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_CHRONOLOGY_TIME_LIMIT:
      return {
        ...state,
        chronology: {
          ...(state.chronology || {}),
          [action.key]: action.value,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_TRAVEL_TIME_LIMIT:
      return {
        ...state,
        travelTime: {
          ...(state.travelTime || {}),
          [action.key]: action.value,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_MAP_INFOS:
      return {
        ...state,
        map: {
          ...state?.map,
          ...action.map,
          initialized: true,
        },
      };
    case FlowActionTypes.SET_INITIALIZED:
      return {
        ...state,
        initialized: action.value,
      };
    case FlowActionTypes.SET_TRAFFIC_INFOS:
      return {
        ...state,
        traffic: { ...action.data },
      };
    case FlowActionTypes.SET_CATEGORY_COUNT_GRAPH:
      return {
        ...state,
        categoryCount: { ...action.data, initialized: true },
      };
    case FlowActionTypes.SET_CATEGORY_COUNT_TIME_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          categoryCount: {
            ...state.filters.categoryCount,
            [action.key]: action.value,
          },
        },
      };
    case FlowActionTypes.SET_TRAFFIC_CHART:
      return {
        ...state,
        trafficChart: { ...action.data },
      };
    case FlowActionTypes.SET_TRAFFIC_CHART_TIME_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          trafficChart: {
            ...state.filters.trafficChart,
            [action.key]: action.value,
          },
        },
      };
    case FlowActionTypes.SET_TRAFFIC_CHART_INITIALIZED:
      return {
        ...state,
        trafficChart: { ...state.trafficChart, initialized: action.value },
      };
    default:
      return state;
  }
};

export default FlowReducer;
